import {Component, OnInit, Inject} from 'ng-metadata/core';
import {SearchService} from "../../search/search.service";
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';

@Component({
    selector: 'prm-performance-monitor',
    templateUrl: 'components/analytics/performanceMonitor/performance-monitor.html',
})

export class PrmPerformanceMonitor implements OnInit{

    private displayMonitor= false;

    constructor(private searchService: SearchService,
                private configurationUtil : ConfigurationUtil,
                @Inject('$scope') private $scope: angular.IScope,
                @Inject('$timeout') private $timeout: angular.ITimeoutService) {
        this.$scope.$watch(()=>{return this.searchService.isSearchInProgress()}, (newValue)=>{
            if (newValue){
                this.displayMonitor= false
            }
            else{
                this.$timeout(()=>{this.displayMonitor= true}, 2000);
            }
        });
    }

    ngOnInit() {
    }

    get isSuprima(){
        return this.configurationUtil.isSuprima();
    }

    get totalSearchTime(){
        return window.appPerformance.timeStamps['search result displayed'] - window.appPerformance.timeStamps['search api send'];
    }

    get searchApiTime(){
        return window.appPerformance.timeStamps['after search api'] - window.appPerformance.timeStamps['search api send'];
    }

    get resultsRenderTime(){
        return window.appPerformance.timeStamps['search result displayed'] - window.appPerformance.timeStamps['after search api'];
    }

    get totalSearchServerTime(){
        return window.appPerformance.serverTimeLog['BriefSearchDeltaTime'];
    }

    get searchServerTime(){
        return window.appPerformance.serverTimeLog['DoSearchPrimoResultDeltaTime'];
    }

    get deliveryManagerServerTime(){
        return window.appPerformance.serverTimeLog['FullEndDMDataDeltaTime'];
    }
    get serverTimeLog(){
        return window.appPerformance.serverTimeLog;
    }

    get formattedServerTimeLog() {
        let serverTimeLog = window.appPerformance.serverTimeLog;
        let callTree = 
            {COMBINED_SEARCH_TIME:{
                time:serverTimeLog.COMBINED_SEARCH_TIME, 
                calls:{
                    BUILD_BLEND_AND_CACHE_RESULTS:{time: serverTimeLog.BUILD_BLEND_AND_CACHE_RESULTS},
                    BUILD_COMBINED_RESULTS_MAP:{time: serverTimeLog.BUILD_COMBINED_RESULTS_MAP},
                    PRIMA_LOCAL_SEARCH_TOTAL:{time:serverTimeLog.PRIMA_LOCAL_SEARCH_TOTAL, calls:{
                        PRIMA_LOCAL_INFO_FACETS_BUILD_DOCS_HIGHLIGHTS:{time: serverTimeLog.PRIMA_LOCAL_INFO_FACETS_BUILD_DOCS_HIGHLIGHTS},
                        CALL_SOLR_GET_IDS_LIST:{time:serverTimeLog.CALL_SOLR_GET_IDS_LIST},
                        BUILD_RESULTS_RETRIVE_FROM_DB: {time:serverTimeLog.BUILD_RESULTS_RETRIVE_FROM_DB, calls:{
                            RETRIVE_FROM_DB_RECORDS: {time:serverTimeLog.RETRIVE_FROM_DB_RECORDS},
                            RETRIVE_FROM_DB_COURSE_INFO: {time:serverTimeLog.RETRIVE_FROM_DB_COURSE_INFO},
                            RETRIVE_FROM_DB_RELATIONS: {time:serverTimeLog.RETRIVE_FROM_DB_RELATIONS},
                            RETRIVE_COLLECTION_DISCOVERY_INFO: {time:serverTimeLog.RETRIVE_COLLECTION_DISCOVERY_INFO},
                        }},
                        PRIMA_LOCAL_SEARCH_SET_AVALIABILITY: {time:serverTimeLog.PRIMA_LOCAL_SEARCH_SET_AVALIABILITY},

                    }},
                    PC_SEARCH_TIME_TOTAL:{time:serverTimeLog.PC_SEARCH_TIME_TOTAL, calls: {
                        PC_SEARCH_CALL_TIME:{time:serverTimeLog.PC_SEARCH_CALL_TIME},
                        PC_BUILD_JSON_AND_HIGLIGHTS :{time:serverTimeLog.PC_BUILD_JSON_AND_HIGLIGHTS},

                    }},
                    SUMMON_SEARCH_TIME_TOTAL:{time:serverTimeLog.SUMMON_SEARCH_TIME_TOTAL, calls: {
                        SUMMON_CALL_SEARCH:{time:serverTimeLog.SUMMON_CALL_SEARCH},
                        SUMMON_BUILD_RESULT_CONVERT_TO_JSON :{time:serverTimeLog.SUMMON_BUILD_RESULT_CONVERT_TO_JSON},
                    }},
                    WORLDCAT_SEARCH_TIME_TOTAL:{time:serverTimeLog.WORLDCAT_SEARCH_TIME_TOTAL, calls: {
                        WORLDCAT_SEARCH_CALL_TIME:{time:serverTimeLog.WORLDCAT_SEARCH_CALL_TIME},
                        WORLDCAT_BUILD_JSON_AND_HIGLIGHTS :{time:serverTimeLog.WORLDCAT_BUILD_JSON_AND_HIGLIGHTS},
                    }},
                },
                PROCESS_COMBINED_RESULTS:{time: serverTimeLog.PROCESS_COMBINED_RESULTS},
                FEATURED_SEARCH_TIME:{time: serverTimeLog.FEATURED_SEARCH_TIME},
            }
        };
        return JSON.stringify(callTree,(key,val) => {
            if ( key === "" || key === "time" || key === "calls" || (val && val.time !== undefined) ) {
                return val; // return as is
            } else { 
                return undefined; // remove from result
        }
        },'\t');
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/analytics/performanceMonitor/performanceMonitor.directive.ts